import React, { useState } from 'react';
import { Card, CardBody, CardFooter } from '../../../../components/card/card';
import { CardHeader } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Pagination from '../../../../components/Shared/Pagination/Pagination';
import { useAppSelector } from '../../../../store/hooks';
import Loading from '../../../../components/Shared/Loader/Loading';


interface Props {
  itemsByPerson: any[];
  selectedPersons: any[];
  setSelectedPersons: React.Dispatch<React.SetStateAction<any[]>>;
  removeFromPlan: () => void;
}

const PersonsInPlan = ({
  itemsByPerson,
  selectedPersons,
  setSelectedPersons,
  removeFromPlan,
}: Props) => {
  const { loading, error } = useAppSelector((s) => s.Raqeeb);



  const { t, i18n } = useTranslation();
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage] = useState(8);

  // const filteredSearch = itemsByPerson?.slice()?.filter((item: any) => {
  //   const searchLowerCase = search.toLowerCase();
  //   return (
  //     item.name?.toLowerCase().includes(searchLowerCase) ||
  //     item.name2?.toLowerCase().toString().includes(searchLowerCase) || 
  //     item.employeeNumber?.toLowerCase().toString().includes(searchLowerCase) 
  //   );
  // });

  const filteredSearch = itemsByPerson?.filter((item: any) => {
    const searchLowerCase = search.toLowerCase();
    const fieldsToCheck = [item.name, item.name2, item.employeeNumber];
  
    return fieldsToCheck.some(field => 
      field?.toString().toLowerCase().includes(searchLowerCase)
    );
  });

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = filteredSearch?.slice(indexOfFirstData, indexOfLastData);

  const handleCheckboxChange = (row: any) => {
    setSelectedPersons((prevSelectedRows: any) => {
      const isSelected = prevSelectedRows.some((item: any) => item.id === row.id);
      if (isSelected) {
        return prevSelectedRows?.filter((item: any) => item.id !== row.id);
      } else {
        return [...prevSelectedRows, row];
      }
    });
  };

  // دالة لتحديد الكل أو إلغاء تحديد الكل
  const toggleSelectAll = () => {
    const allSelected = currentData.every((item) =>
      selectedPersons.some((selected) => selected.id === item.id)
    );

    if (allSelected) {
      // إلغاء تحديد جميع العناصر في الصفحة الحالية
      const deselectedItems = selectedPersons?.filter(
        (selected) => !currentData.some((item) => item.id === selected.id)
      );
      setSelectedPersons(deselectedItems);
    } else {
      // تحديد جميع العناصر في الصفحة الحالية
      const newSelectedItems = [
        ...selectedPersons,
        ...currentData?.filter(
          (item) => !selectedPersons.some((selected) => selected.id === item.id)
        ),
      ];
      setSelectedPersons(newSelectedItems);
    }
  };


  return (
    <div className="col-lg-6 mb-1   ">
      <Card classNeme="h-100">
        <CardHeader className="fw-bold small bg-success bg-opacity-25">
          {/* <h6 className="m-1"> الموظفون المعينون</h6> */}
          <h6 className="m-1">الموظفين المدرجين في الخطة</h6>
        </CardHeader>
        <Loading loading={loading} error={error}>
          <CardBody>
            <div className="row">
              <div className="col-12">
                <div className="d-flex align-items-center mb-2">
                  <div className="flex-fill position-relative me-2">
                    <div className="input-group">
                      <div
                        className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 pe-0"
                         >
                        <i className="fa fa-search opacity-5"></i>
                      </div>
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control ps-35px"
                        onChange={(e) => {
                          setSearch(e.target.value);
                          setCurrentPage(1);
                        }}
                        placeholder={t('Search') + ' ...'}
                      />
                    </div>
                  </div>
                  <button onClick={toggleSelectAll} className="btn btn-theme">
                    {currentData.every((item) =>
                      selectedPersons.some((selected) => selected.id === item.id)
                    ) ? (
                      <>
                        <i className="fa fa-times-circle"></i> إلغاء تحديد الكل
                      </>
                    ) : (
                      <>
                        <i className="fa fa-check-circle"></i> تحديد الكل
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-hover">
                <tbody>
                  {currentData?.map((item) => (
                    <tr
                      key={item.id}
                      onClick={() => handleCheckboxChange(item)}
                      style={{ cursor: 'pointer' }}>
                      <td style={{ width: '5%' }}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`checkbox-inv-${item.id}`}
                          checked={selectedPersons.some((row) => row.id === item.id)}
                          onChange={() => handleCheckboxChange(item)}
                        />
                      </td>
                      <td style={{ width: '55%' }}>
                        {i18n.language === 'en' ? item.name : item.name2}
                      </td>
                      <td style={{ width: '40%' }}>
                        {i18n.language === 'en' ? item.rotationPlanName : item.rotationPlanName2}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <Pagination
              filteredData={filteredSearch}
              dataPerPage={dataPerPage}
              handlePagination={(pageNumber: any) => setCurrentPage(pageNumber)}
              currentPage={currentPage}
            />

            <CardFooter className="mt-2   px-0 ">
              <div className="d-flex justify-content-between ">
                <button
                  disabled={selectedPersons.length === 0}
                  onClick={removeFromPlan}
                  className="btn  btn-lg  btn-danger w-100 rounded-0">
                  <i className="fa fa-user-times me-2"></i>إزالة من الخطة
                </button>
              </div>
            </CardFooter>
          </CardBody>
        </Loading>
      </Card>
    </div>
  );
};

export default PersonsInPlan;
